import { Box, Chip, Typography, Tooltip } from "@mui/joy";
import { CalendarDays, Clock, Info, Kanban, PackageCheck } from "lucide-react";
import moment from "moment";

import { KanbanBoard } from "../../";
import CalendarV2 from "../../CalendarV2";
import { NavigationTabs } from "../../../components/Project/components/ProjectDetails/NavigationTabs";
import { useJobExecution } from "../hooks";
import TaskActionComponent from "../../../components/Tasks/components/TaskAction";
import { useState } from "react";

const taskDetails = `The Job Execution phase involves carrying out the roofing work, including site preparation,
                            material installation, crew coordination, safety enforcement, and mid-project inspections.
                            It ensures proper execution of the project while maintaining quality and safety standards.`;

function TaskDetails() {
    return (
        <Box sx={{ minWidth: 300, maxWidth: "100%", width: 400, p: 1 }}>
            <Typography>{taskDetails}</Typography>
        </Box>
    );
}
const tabList = (activeTask: any, setKanbanTasks: (e: any) => void) => [
    {
        name: "Board",
        icon: <Kanban size={18} />,
        component: <KanbanBoard setKanbanTasks={setKanbanTasks} />, // assuming this one doesn't need activeTask
    },
    {
        name: "Calendar",
        icon: <CalendarDays size={18} />,
        component: <CalendarV2 />, // Job Execution task ID will be found dynamically
    },
];

interface ITaskComponent {
    activeTask: any;
    onComplete: any;
    actionProgress: any;
}

export default function TaskComponent(props: ITaskComponent) {
    const { activeTask, onComplete, actionProgress } = props;
    const { CreatedAt, Status } = activeTask;
    const { tasks } = useJobExecution(activeTask);
    const [kanbanTaskTasks, setKanbanTasks] = useState<any>({});

    //console.log(kanbanTaskTasks?.[3]?.tasks, tasks);
    return (
        <Box mt={2} ml={1} mr={1}>
            <Typography startDecorator={<PackageCheck size={16} />} level="body-sm" gutterBottom>
                Task
            </Typography>
            <Typography
                level="h4"
                sx={{ fontWeight: 500, display: "flex", alignItems: "center", gap: 0.5 }}
                component={"div"}
            >
                Job Execution
                <Tooltip
                    arrow
                    title={<TaskDetails />}
                    variant="outlined"
                    sx={{ border: "1px solid", borderColor: "divider" }}
                >
                    <Info size={12} />
                </Tooltip>
            </Typography>

            <Box mt={2} display={"flex"} gap={1}>
                <Chip
                    color={Status === "COMPLETED" ? "success" : "warning"}
                    sx={{ fontSize: 12, border: "1px solid", borderColor: "divider" }}
                >
                    {Status}
                </Chip>
                <Chip color="neutral" variant="outlined" sx={{ fontSize: 12 }} startDecorator={<Clock size={14} />}>
                    Created On: {moment(CreatedAt).format("MM/DD/YYYY")}
                </Chip>
            </Box>
            <Box mt={2} ml={-2} mr={-2}>
                <NavigationTabs tabList={tabList(activeTask, setKanbanTasks)} />
            </Box>
            <TaskActionComponent
                taskName="Job Execution"
                onComplete={onComplete}
                actionProgress={actionProgress}
                isNextEligible={kanbanTaskTasks?.[3]?.tasks?.length === tasks?.length}
                taskId={activeTask?.Id}
            />
        </Box>
    );
}
